import { Component } from '@angular/core';

@Component({
  selector: 'app-non-confusion',
  templateUrl: './non-confusion.component.html',
  styleUrl: './non-confusion.component.scss'
})
export class NonConfusionComponent {

}
